import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = {
  key: 0,
  class: "d-block fs-6"
}
const _hoisted_3 = {
  key: 1,
  class: "d-block fs-6"
}
const _hoisted_4 = {
  key: 0,
  class: "badge badge-light-primary"
}
const _hoisted_5 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "fas fa-ellipsis-h" }, null, -1)
const _hoisted_7 = { class: "menu-item-wrapper" }
const _hoisted_8 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-clipboard-list" })
], -1)
const _hoisted_10 = {
  key: 1,
  style: {"white-space":"nowrap"},
  class: "menu-item"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-clipboard-list" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Search, {
      selectData: _ctx.filterObject,
      filter: true,
      filterPlaceholder: 'message.SELECT',
      onSearch: _ctx.searchHandler,
      inputPlaceholder: "message.ENTER_KEY_TO_SEARCH",
      onReloadListing: _cache[1] || (_cache[1] = ($event: any) => (_ctx.get_subscriptions(0, true)))
    }, null, 8, ["selectData", "filterPlaceholder", "onSearch"]),
    _createVNode(_component_Table, {
      columns: _ctx.columns,
      rows: _ctx.subscriptions,
      pagination: _ctx.pagination,
      onHandleCurrentChange: _ctx.handleCurrentChange,
      padding: 5,
      loading: _ctx.loader
    }, {
      "cell-name": _withCtx(({row:item}) => [
        _createTextVNode(_toDisplayString(item?.customer?.user?.name), 1)
      ]),
      "cell-payment_type": _withCtx(({row:item}) => [
        _createTextVNode(_toDisplayString(_ctx.$t('message.' + item?.payment_type)), 1)
      ]),
      "cell-tenure": _withCtx(({row:item}) => [
        (item?.tenure)
          ? (_openBlock(), _createBlock("span", _hoisted_2, _toDisplayString(_ctx.$t('message.' + item?.tenure)), 1))
          : (_openBlock(), _createBlock("span", _hoisted_3, "N/A"))
      ]),
      "cell-status": _withCtx(({row:item}) => [
        (item?.status == 1)
          ? (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('message.ACTIVE')), 1))
          : (_openBlock(), _createBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('message.INACTIVE')), 1))
      ]),
      "cell-actions": _withCtx(({row:item}) => [
        _createVNode("button", {
          class: "action-btn",
          type: "button",
          onClick: ($event: any) => (_ctx.dropdownHandler(_ctx.activeIndex, item?.id))
        }, [
          _hoisted_6,
          _createVNode("div", {
            class: ["dropdown-menu dropdown-menu-end action-dropdown", { active: _ctx.activeIndex === item?.id }]
          }, [
            _createVNode("div", _hoisted_7, [
              (_ctx.$can('view_subscription_details'))
                ? (_openBlock(), _createBlock("div", _hoisted_8, [
                    _createVNode("a", {
                      onClick: ($event: any) => (_ctx.handleView(item)),
                      class: "menu-link me-1"
                    }, [
                      _hoisted_9,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('message.VIEW')), 1)
                    ], 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.$can('change_subscription_status') && item?.order_discounts?.discount?.discount_type != 'SUBSCRIPTION_DISCOUNT')
                ? (_openBlock(), _createBlock("div", _hoisted_10, [
                    _createVNode("a", {
                      onClick: ($event: any) => (_ctx.handleToggle(item)),
                      class: "menu-link me-1"
                    }, [
                      _hoisted_11,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('message.CHANGE_STATUS')), 1)
                    ], 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2)
        ], 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["columns", "rows", "pagination", "onHandleCurrentChange", "loading"])
  ]))
}